// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"loading-module--loadingScreen--JR1NB","inActive":"loading-module--inActive--3XnZq","loader":"loading-module--loader--2PIYj","load8":"loading-module--load8--38eNL"};